import { Spinner } from '@shopify/polaris';
import { ReactNode, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { PATH } from '../../constants';
import useConfirmationNavigate from '../../hooks/useConfirmationNavigate';
import { useGetOnboardingStepQuery, useGetUserPlanQuery } from '../../redux/api/api.caller';
import commonSlice from '../../redux/features/common.slice';
import dashboardPageSlice from '../../redux/features/dashboard.slice';
import { resetState as resetOnboardingGuideState } from '../../redux/features/onboardingGuide.slice';

interface Props {
  children: ReactNode;
}

export default function AppInitializer({ children }: Props) {
  const { data: onboardingData, isLoading: isOnboardingLoading, isFetching: isOnboardingFetching } = useGetOnboardingStepQuery();
  const { isLoading: isUserPlanLoading } = useGetUserPlanQuery({});
  const isInitializing = isOnboardingLoading || isUserPlanLoading;
  const hasInitialized = useRef(false);
  if (!isInitializing) hasInitialized.current = true;

  const navigate = useConfirmationNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isInitializing || isOnboardingFetching) return;
    const onboardingStatus = onboardingData?.data?.onboardingStatus;
    if (onboardingStatus == null) return;

    if (!onboardingStatus && pathname !== PATH.WELCOME) {
      navigate(PATH.WELCOME, { replace: true });
    } else if (onboardingStatus && pathname === PATH.WELCOME) {
      navigate(PATH.DASHBOARD, { replace: true });
    }

    if (!onboardingStatus) {
      dispatch(dashboardPageSlice.actions.resetState());
      dispatch(commonSlice.actions.resetState());
      dispatch(resetOnboardingGuideState());
    }
  }, [onboardingData, pathname, navigate, dispatch, isInitializing, isOnboardingFetching]);

  if (!hasInitialized.current)
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spinner size="large" />
      </div>
    );
  return <>{children}</>;
}
